import "../../../styles/dlfEditing/column/columnRange.css";
import { AdvancedTooltip } from "../../tooltips/AdvancedTooltip";
import { ExpandingTooltip } from "../../tooltips/ExpandingTooltip";

export { ColumnRange };

type Props = {
  label: string;
  value: number;
  labelOnTop?: boolean;
  disabled?: boolean;
  /**
   * Called by an <input type="range" /> node's onChange handler
   */
  onMove(value: number): void;

  /**
   * Called by an <input type="range" /> node's onBlur handler
   */
  onChange(value: number): void;
  tooltipText: ExpandingTooltip;
};

const ColumnRange = (props: Props) => {
  return (
    <div className={`columnRange ${props.labelOnTop ? "vertical" : ""}`}>
      <AdvancedTooltip tooltipText={props.tooltipText}>
        {(tProps) => <span {...tProps}>{props.label}</span>}
      </AdvancedTooltip>
      <input
        type={"range"}
        step={1}
        min={0}
        max={100}
        defaultValue={props.value}
        disabled={props.disabled}
        onMouseUp={(e) => {
          const val = parseInt(e.currentTarget.value);
          // setValue(val);
          props.onChange(val);
        }}
        onChange={(e) => {
          const val = parseInt(e.target.value);
          // setValue(val);
          props.onMove(val);
        }}
      />
    </div>
  );
};
